import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { FlowType, IProofReading } from 'src/app/models/proofreading.model';
import { AlertService } from 'src/app/services/alert.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { ProjectService } from 'src/app/services/project.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { AuthService } from 'src/app/services/auth.service';
import { IMasterGroup } from 'src/app/project-dashboard/project-dashboard/project-dashboard.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-project-cards-skeleton',
    templateUrl: './project-cards-skeleton.component.html',
    styleUrls: ['./project-cards-skeleton.component.scss'],
})
export class ProjectsCardsSkeletonComponent extends ViewComponent {

    // @Input() masterGroup: IMasterGroup;

    // get master() {
    //     return this.masterGroup.master;
    // }

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected s_proofreadings: ProofreadingService,
        protected s_projects: ProjectService,
        protected translate: TranslateService
    ) {
        super(route, router, s_alert, s_loader, s_auth);
    }

    public theme_bars_base = {
        "background-color": "#e5e5e5",
        height: "2rem",
    };

    public theme_buttons = {
        "background-color": "#e5e5e5",
        width: "2rem",
        height: "2rem",
        "border-radius": "50%",
    };

    public master_theme_bars() {
        return {
            height: "2rem",
            width: `100%`,
        };
    }

    // getPrefixRelecture(flow: FlowType) {
    //     return ProofreadingService.getPrefixRelecture(flow);
    // }

    // async newChildProject(identifier: string) {
    //     if (identifier) {
    //         let masterJob = await this.s_projects.find({ identifier });
    //         if (masterJob[0]) {
    //             this.s_projects.masterData = masterJob[0];
    //             this.s_projects.childData = null;
    //             this.router.navigate(["/project/create/child"], { queryParams: { noReset: '1' } });
    //         }
    //     }
    // }
}